import { configureStore } from '@reduxjs/toolkit';
import intakeFormSettingsReducer from 'reduxStateSlice/intakeFormSettings';
import appStateSettingsReducer from 'reduxStateSlice/appState';
import patientReducer from 'reduxStateSlice/patient';
import symptomsReducer from 'reduxStateSlice/symptoms';
import visitNotesReducer from 'reduxStateSlice/visitNotes';
import communiqueReducer from 'reduxStateSlice/communique';
import consentFormReducer from 'reduxStateSlice/consentForm';
import organizationMediaReducer from 'reduxStateSlice/organizationMedia';
import organizationReducer from 'reduxStateSlice/organization';
import appointmentReducer from 'reduxStateSlice/appointment';

export const store = configureStore({
  reducer: {
    intakeFormSettings: intakeFormSettingsReducer,
    appStateSettings: appStateSettingsReducer,
    patient: patientReducer,
    symptoms: symptomsReducer,
    visitNote: visitNotesReducer,
    communique: communiqueReducer,
    consentForm: consentFormReducer,
    organizationMedia: organizationMediaReducer,
    organization: organizationReducer,
    appointment: appointmentReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
